<template>
    <div class="video-placeholder" :class="{ small: small }">
        <div class="circle-responsive">
            <p class="circle-text" :class="{ small: small }">
                {{ initialsName }}
            </p>
        </div>
    </div>
</template>

<script>
export default {
    name: "video-placeholder",
    props: {
        name: {
            type: String,
            default: "",
        },
        small: {
            type: Boolean,
            default: false,
        },
    },
    computed: {
        initialsName() {
            return this.getInitials(this.name);
        },
    },
    methods: {
        getInitials(name) {
            name = name.trim().toUpperCase();
            let words = name.split(" ");
            let initials = [];
            words.map(function (w) {
                let letter = w.charAt(0).trim();
                if (letter !== "") {
                    initials.push(letter);
                }
            });
            return initials.join("");
        },
    },
};
</script>

<style lang="scss" scoped>
.video-placeholder {
    width: 640px;
    height: 480px;

    &.small {
        width: 100%;
        height: 150px;
    }

    background-color: black;
    display: flex;
    justify-content: center;
    align-items: center;
}

.circle-responsive {
    background: #ddd;
    border-radius: 50%;
    height: 50%;
    width: 39%;
    display: flex;
    justify-content: center;
    align-items: center;
}

.circle-text {
    text-align: center;
    font-size: 4em;
    font-weight: bold;

    &.small {
        font-size: 2em;
    }
}
</style>